// src/config/apiConfig.js

// Detecta o ambiente atual
const hostname = window.location.hostname;

const isLocalhost =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "0.0.0.0";

const isReplit =
  hostname.includes("replit.dev") || hostname.includes("replit.app");

const isProduction =
  hostname === "slideparamissa.com.br" ||
  hostname === "www.slideparamissa.com.br";

// Função para retornar a URL da API com base no ambiente
function getApiUrl() {
  if (isLocalhost) {
    return "http://localhost:3001";
  }

  if (isReplit) {
    return "https://slideparamissaapi.replit.app";
  }

  if (isProduction) {
    return "https://slideparamissaapi.replit.app";
  }

  return "https://slideparamissaapi.replit.app";
}

function getStripeApiUrl() {
  if (isLocalhost) {
    return "http://localhost:3001";
  }

  if (isReplit || isProduction) {
    return "/api/stripe";
  }

  return "http://localhost:3001";
}

function getAuthApiUrl() {
  if (isLocalhost) {
    return "http://localhost:3001";
  }

  if (isReplit || isProduction) {
    return "";
  }

  return "http://localhost:3001";
}

export const API_URL_ORIGINAL = getApiUrl();
export const API_URL_TEST = getApiUrl();
export const API_URL = getApiUrl();
export const STRIPE_API_URL = getStripeApiUrl();
export const AUTH_API_URL = getAuthApiUrl();

console.log("🌐 API URL configurada:", API_URL_ORIGINAL);
console.log("🔍 Ambiente detectado:", { isLocalhost, isReplit, isProduction });
console.log("🖥️ Hostname:", hostname);
